type Props = {
  height?: string;
  stroke?: string;
  width?: string;
};
const MarketStallIcon = ({
  stroke = 'black',
  width = '24',
  height = '24'
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.88889 4L2 6.5V10.75C2 11.9926 3.11926 13 4.5 13C5.88074 13 7 11.9926 7 10.75C7 11.9926 8.11926 13 9.5 13C10.8807 13 12 11.9926 12 10.75C12 11.9926 13.1193 13 14.5 13C15.8807 13 17 11.9926 17 10.75C17 11.9926 18.1193 13 19.5 13C20.8807 13 22 11.9926 22 10.75V6.5L18.1111 4H5.88889Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <mask
        id="mask0_6_435"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="3"
        y="12"
        width="18"
        height="10"
      >
        <path
          d="M4 12V21H20V12"
          stroke={stroke}
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask0_6_435)">
        <path
          d="M24 10.75C24 13.2985 21.7727 15 19.5 15C18.6029 15 17.7331 14.7432 17 14.2828C16.267 14.7432 15.3971 15 14.5 15C13.6029 15 12.7331 14.7432 12 14.2828C11.267 14.7432 10.3971 15 9.5 15C8.60295 15 7.73305 14.7432 7 14.2828C6.26695 14.7432 5.39705 15 4.5 15C2.22733 15 0 13.2985 0 10.75V23H24V10.75Z"
          fill={stroke}
        />
      </g>
    </svg>
  );
};

export default MarketStallIcon;
